/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface CapturePaymentIntentDTO
 */
export interface CapturePaymentIntentDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CapturePaymentIntentDTO
   */
  paymentIntentId?: string;
}

export interface CapturePaymentIntentDTO extends CapturePaymentIntentDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CapturePaymentIntentDTO
   */
  paymentIntentId: string;
}

export interface CapturePaymentIntentDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof CapturePaymentIntentDTO
   */
  paymentIntentId?: string;
  paymentIntentIdIsSet: boolean;
}

transformDatesMap.set(
  "CapturePaymentIntentDTO",
  function (model: CapturePaymentIntentDTO) {},
);

export type CapturePaymentIntentDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  paymentIntentId: PropertyMeta<MetaTypeBase<string>>;
}>;

export var CapturePaymentIntentDTOMeta: CapturePaymentIntentDTOMetaI =
  {} as CapturePaymentIntentDTOMetaI;
CapturePaymentIntentDTOMeta = typeMeta("CapturePaymentIntentDTO", {
  paymentIntentId: propertyMeta(
    "paymentIntentId",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = CapturePaymentIntentDTOMeta;

registerMeta(() => {});

export class CapturePaymentIntentDTOTracked implements CapturePaymentIntentDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  paymentIntentId__I?: string = undefined;
  paymentIntentIdIsSet: boolean = false;
  set paymentIntentId(v: undefined | string) {
    if (v !== undefined) {
      this.paymentIntentId__I = v;
      this.paymentIntentIdIsSet = true;
    } else {
      this.paymentIntentId__I = v || undefined;
      this.paymentIntentIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get paymentIntentId() {
    return this.paymentIntentId__I;
  }
  constructor(
    config?: CapturePaymentIntentDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: CapturePaymentIntentDTOOptional,
    options?: AssignOptions,
  ): CapturePaymentIntentDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.paymentIntentId &&
      this.paymentIntentIdApplyFilter(optionsRequired.filter)
    ) {
      this.paymentIntentId = config.paymentIntentId;
      if (optionsRequired.unassign) this.paymentIntentIdIsSet = false;
      else this.paymentIntentIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CapturePaymentIntentDTOTrackedI {
    const cloned = {} as CapturePaymentIntentDTOTrackedI;
    if (
      this.paymentIntentIdIsSetDeep() &&
      this.paymentIntentIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentIntentIdIsSet = true;
      cloned.paymentIntentId = this.paymentIntentId;
    } else {
      //cloned.paymentIntentIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CapturePaymentIntentDTOTrackedI {
    if (!this.paymentIntentIdApplyFilter(filter))
      this.paymentIntentIdIsSet = false;

    return this;
  }
  paymentIntentIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CapturePaymentIntentDTOMeta.paymentIntentId,
      CapturePaymentIntentDTOMeta,
      this.paymentIntentId,
      this,
    );
  }
  paymentIntentIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentIntentIdIsSet && this.paymentIntentIdApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.paymentIntentIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
